import { connect } from 'react-redux'
import { getTimeline } from '@selectors/data/timeline_selectors.js'

import Rating from '../components/rating.jsx'

const mapStateToProps = (state, props) => {
  const timeline = getTimeline(state, props)
  return {
    timeline,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Rating)
